import { useState } from 'react';
import { linkSkillIconPath } from '../../lib/linkIcons';

interface LinkSkillIconProps {
  skillName: string;
}

/** Icons render at 32px everywhere — matches the 32x32 assets in public/link-icons/. */
const SIZE_PX = 32;
const SIZE_CLASS = 'size-8';

/**
 * Same-origin, decorative link-skill icon (REV3 spec) — see
 * `frontend/scripts/fetch-link-icons.mjs` for how `public/link-icons/<slug>.png` gets populated
 * (32x32 icons from the MapleStory Wiki, one per link skill — shared-group classes share a file).
 * Renders nothing (not a broken-image glyph, not a letter tile — unlike `BossIcon`, the skill name
 * is always visible as adjacent text right next to where the icon would sit, so there's nothing
 * useful a fallback tile would add) for any skill the fetch script found no wiki art for, or if the
 * file 404s for any other reason — the row keeps its existing iconless layout either way.
 */
export function LinkSkillIcon({ skillName }: LinkSkillIconProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return null;
  }

  return (
    <img
      src={linkSkillIconPath(skillName)}
      alt=""
      aria-hidden="true"
      loading="lazy"
      width={SIZE_PX}
      height={SIZE_PX}
      className={[SIZE_CLASS, 'shrink-0 rounded-lg bg-bg-elevated-hover object-contain'].join(' ')}
      onError={() => setFailed(true)}
    />
  );
}
